import { ManageCategoriesView } from './manage-categories.component';
import { withCategories } from '../../common/components/categories-picker.container';

export const ManageCategories = withCategories(ManageCategoriesView);
